module.exports = "<div class=\"custom-modal-header--scheduling\" style=\"border-radius: {{ ::$ctrl.popupRadius }}\"> <div id=\"scheduling\"></div> </div> ";